// extracted by mini-css-extract-plugin
export var container = "_5f-0";
export var containerTopRight = "_5f-1";